/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-18 14:49:39
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-07-15 15:46:59
 * @Description: 学生类型
 * @FilePath: /hsylc2021/src/utils/stuType.js
 */
import STUDENT from '../constants/student';
export const STU_TYPE = STUDENT.STU_TYPE;
export const STU_TYPE_STR = STUDENT.STU_TYPE_STR;
export default STUDENT.STU_TYPE;
export const getStuTypeStr = type => {
  if (type === STU_TYPE.STUDENT || type === STU_TYPE.SSI) {
    return STU_TYPE_STR.HIGH_SCHOOL;
  } else {
    return STU_TYPE_STR.COLLAGE;
  }
};
